export default import.meta.ROLLDOWN_FILE_URL_Ca4LBKjKib5nRGc7lsyQwg